<template>
  <div class="w-full">

    <div class="bg-green-light2">
      <QuizDragDrop :item="quiz"></QuizDragDrop>
    </div>

    <div v-if="! scenarioIsEvaluation && ! showResponse" @click="submitQuiz" class="flex justify-center mx-auto items-center py-8 "
         :class="canSubmit ? 'text-orange-primary cursor-pointer' : 'opacity-50 text-green-light'">

      <div class="">{{ t('button.valider_reponses') }}</div>
      <div  class="flex-shrink-0 ml-4 border-2  rounded-full px-2 py-2" :class="canSubmit ? 'border-orange-primary' : 'opacity-50 border-green-light'">
        <div class="w-6">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14 5l7 7m0 0l-7 7m7-7H3" />
          </svg>
        </div>
      </div>

    </div>

  </div>


</template>


<script>
import QuizDragDrop from "@components/Quiz/QuizDragDrop";
import {useQuizDragDrop} from "@composables/quizDragDrop";
import {useScenario} from "@composables/scenario";
import {scrollTo} from "@/helpers";
import {watchEffect} from "vue";
import {useI18n} from "vue-i18n";

export default {

  props: {
    node: {
      type: Object,
      required: true
    }
  },

  components: {QuizDragDrop},

  setup(props) {
    const {t} = useI18n()
    const {formatDragDropContent, setCurrentNodeValidity, setCurrentNodeType, saveNodeResults, scenarioIsEvaluation, setHasSubmitNode} = useScenario()
    const {setQuizDragDrop, quiz, showResponse, submit: validateQuiz, canSubmit} = useQuizDragDrop()

    setHasSubmitNode(false)
    setQuizDragDrop(formatDragDropContent.value)
    setCurrentNodeValidity(false)
    setCurrentNodeType('drag_drop')


    watchEffect( () => {
      if( canSubmit.value && scenarioIsEvaluation.value) {
        saveNodeResults(props.node.id, 'drag_drop',quiz.value)
        setCurrentNodeValidity(true)
      }
    })

    const submitQuiz = () => {
      if( ! canSubmit.value ) return
      validateQuiz()
      saveNodeResults(props.node.id, 'drag_drop',quiz.value)
      setCurrentNodeValidity(true)
      scrollTo(document.documentElement, 0)
    }

    return {t, quiz, showResponse, canSubmit, submitQuiz, scenarioIsEvaluation}

  }
}
</script>